import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Building2, Settings, AlertTriangle } from 'lucide-react';
import { mandantenAPI } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import MandantSettingsModal from '../components/MandantSettingsModal';

export default function MandantPicker() {
  const { user } = useAuth();
  const [mandanten, setMandanten] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);

  const canEdit = user?.role === 'kanzlei_admin' || user?.role === 'steuerberater';

  const reload = () => {
    setLoading(true);
    return mandantenAPI
      .list()
      .then((r) => setMandanten(r.data))
      .catch((err) => toast.error(err.response?.data?.detail || 'Mandanten konnten nicht geladen werden'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { reload(); }, []);

  const datevMissing = (m) =>
    m.datev_berater_nr == null || m.datev_mandant_nr == null || m.datev_wj_beginn == null;

  return (
    <div className="page">
      <header className="page-header">
        <h1>Mandanten</h1>
      </header>

      {loading ? (
        <div className="muted">Lädt…</div>
      ) : mandanten.length === 0 ? (
        <div className="card empty">
          Keine Mandanten zugewiesen. Bitte den Kanzlei-Admin kontaktieren.
        </div>
      ) : (
        <div className="grid">
          {mandanten.map((m) => (
            <div key={m.id} className="card mandant-card" style={{ position: 'relative' }}>
              <Link to={`/mandanten/${m.slug}/belege`} style={{ display: 'flex', gap: 12, textDecoration: 'none', color: 'inherit', flex: 1 }}>
                <Building2 size={24} className="muted" />
                <div style={{ flex: 1 }}>
                  <div className="mandant-name">{m.name}</div>
                  <div className="mandant-meta muted">
                    {m.skr_variant} · {m.slug}
                    {m.ust_id && <> · {m.ust_id}</>}
                  </div>
                  {datevMissing(m) && (
                    <div className="muted small" style={{ marginTop: 4, color: '#854d0e' }}>
                      <AlertTriangle size={11} style={{ verticalAlign: 'middle' }} />{' '}
                      DATEV-Stammdaten unvollständig
                    </div>
                  )}
                </div>
              </Link>
              {canEdit && (
                <button
                  className="btn-text"
                  onClick={(e) => { e.stopPropagation(); setEditing(m); }}
                  title="DATEV-Einstellungen"
                  style={{ position: 'absolute', top: 8, right: 8, padding: 4 }}
                >
                  <Settings size={16} />
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      <MandantSettingsModal
        open={!!editing}
        onClose={() => setEditing(null)}
        mandant={editing}
        onSaved={reload}
      />
    </div>
  );
}
